import { CheckboxGroupField as BaseCheckboxGroupField } from '@wyz/ui';
import { useI18n } from '~/common/context';

type CheckboxGroupFieldProps = React.ComponentProps<
  typeof BaseCheckboxGroupField
>;

function CheckboxGroupField(props: Omit<CheckboxGroupFieldProps, 'translate'>) {
  const { t } = useI18n();

  return <BaseCheckboxGroupField {...props} translate={t} />;
}

export default CheckboxGroupField;
